import { LoginCashfitStorage } from './types/login-cashfit-storage'

const storeKey = 'auth_cashfit_v1'
const unitKey = 'unit_cashfit_v1'

export const useLocalStorage = () => {
  const useSetLocalStorage = (data: any) => localStorage.setItem(storeKey, JSON.stringify(data))

  const useFetchLocalStore = (): LoginCashfitStorage | null | any => {
    const dataStore = localStorage.getItem(storeKey)

    if (!dataStore) return null
    const dataStoreParse = JSON.parse(dataStore)

    return dataStoreParse
  }

  const useSetLocalStorageUnit = (data: any) => localStorage.setItem(unitKey, data)

  const useFetchLocalStoreUnit = () => localStorage.getItem(unitKey)

  const getProfiles = () => {
    const data = useFetchLocalStore()
    return data?.perfis || []
  }

  const getId = () => {
    const data = useFetchLocalStore()
    return data?.id || 0
  }

  const getName = () => {
    const data = useFetchLocalStore()
    return data?.nome || ''
  }

  const getEmail = () => {
    const data = useFetchLocalStore()
    return data?.email || ''
  }

  const getUnitId = () => {
    const data = useFetchLocalStore()
    return isProfileAdmin() ? useFetchLocalStoreUnit() || data.idUnidade : data.idUnidade
  }

  // "ADMIN",
  // "ADMINISTRADOR",
  // "ALUNO",
  // "CAIXA",
  // "COMERCIAL",
  // "CONSULTOR",
  // "COORDENADOR",
  // "PERSONAL",
  // "PROFESSOR"

  const isProfileAdmin = () => getProfiles().some((profile: any) => profile == 'ADMIN')

  const isProfileAdministrator = () => getProfiles().some((profile: any) => profile == 'ADMINISTRADOR')

  const isProfileAttendantCash = () => getProfiles().some((profile: any) => profile == 'CAIXA')

  const isProfilePersonal =  () => getProfiles().some((profile: any) => (profile == 'PROFESSOR' || profile == 'PERSONAL' ))

  const clearStorage = () => {
    localStorage.removeItem(storeKey)
    localStorage.removeItem(unitKey)
  }

  return {
    clearStorage,
    useSetLocalStorageUnit,
    useFetchLocalStoreUnit,
    useSetLocalStorage,
    useFetchLocalStore,
    getProfiles,
    getId,
    getName,
    getEmail,
    getUnitId,
    isProfileAdmin,
    isProfileAdministrator,
    isProfileAttendantCash,
    isProfilePersonal
  }
}
